import React from "react";
import Box from "@mui/material/Box";
import { formatRackLocationLabel } from "src/utils/rackLocations";

const parseString = value =>
  value
    .split(",")
    .pop()
    .split(" - ")
    .pop();

const parseArray = item => {
  if (!item) return null;

  const location = formatRackLocationLabel(item);
  return location ? `${location} (${item.sub_qty || 0})` : null;
};

export default function AssetReplayLogRackLocation({ rackLocations }) {
  const getValue = value => {
    if (typeof value === "string") {
      return parseString(value);
    } else if (value && (value.warehouse_locations || value.warehouse_location)) {
      return parseArray(value);
    } else if (Array.isArray(value) && value.length > 0) {
      return parseArray(value[value.length - 1]);
    } else {
      return null;
    }
  };

  return rackLocations.map((value, i) => <Box key={i}>{getValue(value)}</Box>);
}
